import * as React from 'react';
import styled, { css, StyledFunction } from 'styled-components';
import Message from './Message';
import colors from '../colors';

interface Props {
    className?: string;
    children: any;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    primary?: boolean;
    type?: string;
    backgroundColor?: string;
}
interface State {}

class Button extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e: React.MouseEvent<HTMLButtonElement>) {
        e.preventDefault();
        e.stopPropagation();
        if (this.props.onClick) this.props.onClick(e);
    }

    render() {
        return (
            <ButtonWrapper
                className={this.props.className}
                onClick={this.handleClick}
                type={this.props.type || 'button'}
                primary={this.props.primary}
                backgroundColor={this.props.backgroundColor}
            >
                {this.props.children}
            </ButtonWrapper>
        );
    }
}

export default Button;

const button: StyledFunction<any & React.HTMLProps<HTMLInputElement>> = styled.button;
export const ButtonWrapper = button`
    background-color: ${colors.white};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    border: 1px solid ${colors.blue};
    color: ${colors.blue};
    padding: 5px 15px;
    cursor: pointer;
    transition: all .1s ease-in;
    font-size: 14px;
    line-height: 1.3;
    height: initial;
    text-transform: initial;
    letter-spacing: initial;
    &:focus {
        outline: none;
    }
    &:hover {
        color: ${colors.blue};
        transform: scale(1.01);
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
    }
    ${props =>
        props.primary &&
        css`
            background: ${colors.blue};
            color: ${colors.white};
            &:hover {
                color: ${colors.white};
            }
        `};
    ${props =>
        props.backgroundColor &&
        css`
            background-color: ${props.backgroundColor};
            border-color: ${props.backgroundColor};
        `};
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Button.tsx